export const InteractiveAnswers = {
    "客观题正确率":"客观题正确率",
    "试题数":"试题数",
    "参与人数":"参与人数",
    "已批阅":"已批阅",
    "展示互动答题":"展示互动答题",
    "开始批阅":"开始批阅",
    "继续批阅":"继续批阅",
    "批阅完成":"批阅完成",
    "总题数":"总题数",
    "平均分":"平均分",
    "平均答题正确率":"平均答题正确率",
    "平均得分率":"平均得分率",
    "数值评价题平均分":"数值评价题平均分",
    "已答":"已答",
    "未答":"未答",
    "已批":"已批",
    "未批":"未批",
    "未参与":"未参与",
    "批阅状态":"批阅状态",
    "来源":"来源：",
    "互动答题标题":"互动答题标题",
    "互动答题详情":"互动答题详情",
    "截止时间和发布时间冲突":"截止时间和发布时间冲突!",
    "已提交老师还未批改":"已提交，老师还未批改！",
    "等待老师批改点击下方查看试题可以查看作答情况":"等待老师批改，点击下方“查看试题”可以查看作答情况",
    "您的得分":"您的得分：",
    "点击下方查看作答可以查看作答情况":"点击下方“查看作答”可以查看作答情况",
    "点击下方的继续答题可以继续作答试题":"点击下方的“继续答题”可以继续作答试题",
    "测试已结束":"测试已结束！",
    "点击下方的查看试题可以查看作答情况":"点击下方的“查看试题”可以查看作答情况",
    "未参与测试已结束":"未参与！测试已结束！",
    "点击下方的“查看试题”进行查看":"点击下方的“查看试题”进行查看",
    "查看作答":"查看作答",
    "查看试题":"查看试题",
    "继续答题":"继续答题",
    "打分成功":"打分成功",
    "进入听讲模式":"进入听讲模式",
}